import type React from 'react';
import { memo } from 'react';
import styled from 'styled-components';

import { translate } from '@wecasa/i18n';

import TextButton from '@wecasa/web-ui/src/components/button/text-button';

const t = translate('components.promo_code');

const AddPromoCodeWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

type AddPromoCodeProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const AddPromoCode = ({ onClick }: AddPromoCodeProps) => (
  <AddPromoCodeWrapper>
    <TextButton onClick={onClick}>{t('.add_promo_code')}</TextButton>
  </AddPromoCodeWrapper>
);

export default memo(AddPromoCode);
